import React, { useState, useEffect, useCallback } from 'react';
import { FiUsers, FiSearch, FiX, FiPlus, FiEdit3, FiTrash2, FiSave, FiUserPlus, FiPhone, FiMail } from 'react-icons/fi';
import { listarContatos, criarContato, atualizarContato, excluirContato } from '../../../services/contatos';
import { formatarDocumento } from '../../../utils/documento';
import useEsc from '../../../hooks/useEsc';

/* Clientes › Contatos: quem é sócio e quem é o contato que resolve as coisas
   (representante). Todo cliente ativo precisa de pelo menos um. */

export const TIPOS_CONTATO = { socio: 'Sócio', representante: 'Representante' };

const entrada = { width: '100%', padding: '8px 10px', border: '1px solid #d6e2ee', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', font: 'inherit' };
const rotulo = { fontSize: 11, fontWeight: 700, color: '#6B8CAE', textTransform: 'uppercase', letterSpacing: '0.04em', display: 'block', marginBottom: 4 };
const btn = (pri) => ({
  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer',
  border: pri ? 'none' : '1px solid #d6e2ee', background: pri ? '#1e3a5f' : '#fff', color: pri ? '#fff' : '#1e3a5f',
});

/* contato que participa do grupo da empresa (WhatsApp) */
function EtiquetaGrupo() {
  return (
    <span title="Participa do grupo da empresa"
      style={{ marginLeft: 6, fontSize: 10, fontWeight: 800, padding: '1px 6px', borderRadius: 5, background: '#dcfce7', color: '#047857', border: '1px solid #86efac', verticalAlign: 'middle' }}>
      GRUPO
    </span>
  );
}

function mascararTelefone(v) {
  const d = String(v || '').replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

function ModalContatos({ cliente, onFechar, onMudou }) {
  useEsc(onFechar);
  const vazio = { id: null, nome: '', telefone: '', email: '', tipo: 'representante', observacao: '', possui_grupo: false };
  const [form, setForm] = useState(cliente.contatos.length ? null : vazio);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);
  const set = (c, v) => setForm(f => ({ ...f, [c]: v }));

  async function gravar() {
    setErro(''); setSalvando(true);
    try {
      if (form.id) await atualizarContato(form.id, form);
      else await criarContato(cliente.id, form);
      setForm(null);
      await onMudou();
    } catch (e) { setErro(e.message); }
    finally { setSalvando(false); }
  }
  async function excluir(k) {
    if (!window.confirm(`Excluir o contato ${k.nome}?`)) return;
    try { await excluirContato(k.id); await onMudou(); } catch (e) { setErro(e.message); }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(13,31,60,.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, maxHeight: '90vh', overflowY: 'auto', padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: 16, color: '#15365c' }}>Contatos · {cliente.codigo} - {cliente.nome}</h3>
            <p style={{ margin: '2px 0 0', fontSize: 12, color: '#6B8CAE' }}>{formatarDocumento(cliente.cnpj || cliente.cpf)}</p>
          </div>
          <button type="button" style={btn(false)} onClick={onFechar} title="Fechar (Esc)"><FiX size={14} /></button>
        </div>
        {erro && <p style={{ color: '#b91c1c', fontSize: 13, margin: '0 0 10px' }}>{erro}</p>}

        {cliente.contatos.map(k => (
          <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', border: '1px solid #e4edf5', borderRadius: 10, marginBottom: 8 }}>
            <span style={{ fontSize: 10.5, fontWeight: 800, padding: '2px 8px', borderRadius: 6, background: k.tipo === 'socio' ? '#ede9fe' : '#e0f2fe', color: k.tipo === 'socio' ? '#6d28d9' : '#0369a1' }}>
              {TIPOS_CONTATO[k.tipo]}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{k.nome}{k.possui_grupo && <EtiquetaGrupo />}</div>
              <div style={{ fontSize: 12, color: '#6B8CAE' }}>
                {k.telefone && <><FiPhone size={11} /> {mascararTelefone(k.telefone)} </>}
                {k.email && <><FiMail size={11} style={{ marginLeft: 6 }} /> {k.email}</>}
              </div>
              {k.observacao && <div style={{ fontSize: 12, color: '#4A6B8A', marginTop: 3, whiteSpace: 'pre-wrap' }}>{k.observacao}</div>}
            </div>
            <button type="button" style={btn(false)} title="Editar" onClick={() => { setErro(''); setForm({ ...vazio, ...k, telefone: k.telefone || '', email: k.email || '', observacao: k.observacao || '' }); }}><FiEdit3 size={13} /></button>
            <button type="button" style={btn(false)} title="Excluir" onClick={() => excluir(k)}><FiTrash2 size={13} /></button>
          </div>
        ))}

        {form ? (
          <div style={{ border: '1px solid #cbdcf0', background: '#f8fbff', borderRadius: 10, padding: 12, marginTop: 6 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div style={{ gridColumn: '1 / -1' }}>
                <span style={rotulo}>Nome *</span>
                <input style={entrada} value={form.nome} onChange={e => set('nome', e.target.value)} autoFocus />
              </div>
              <div>
                <span style={rotulo}>Telefone</span>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <input style={entrada} inputMode="tel" value={mascararTelefone(form.telefone)} onChange={e => set('telefone', e.target.value.replace(/\D/g, ''))} placeholder="(11) 99999-9999" />
                  <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 700, color: '#047857', whiteSpace: 'nowrap', cursor: 'pointer' }}
                    title="Existe um grupo montado com este contato para os assuntos da empresa">
                    <input type="checkbox" checked={!!form.possui_grupo} onChange={e => set('possui_grupo', e.target.checked)} /> Possui grupo
                  </label>
                </div>
              </div>
              <div>
                <span style={rotulo}>E-mail</span>
                <input style={entrada} value={form.email} onChange={e => set('email', e.target.value)} />
              </div>
              <div>
                <span style={rotulo}>Tipo *</span>
                <select style={entrada} value={form.tipo} onChange={e => set('tipo', e.target.value)}>
                  <option value="representante">Representante (contato que resolve)</option>
                  <option value="socio">Sócio</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <span style={rotulo}>Observações</span>
                <textarea style={{ ...entrada, resize: 'vertical' }} rows={3} maxLength={1000} value={form.observacao}
                  onChange={e => set('observacao', e.target.value)} placeholder="Ex.: falar só pela manhã; cuida do financeiro; prefere WhatsApp" />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              {cliente.contatos.length > 0 && <button type="button" style={btn(false)} onClick={() => setForm(null)}>Cancelar</button>}
              <button type="button" style={btn(true)} onClick={gravar} disabled={salvando}><FiSave size={14} /> {salvando ? 'Gravando...' : 'Gravar contato'}</button>
            </div>
          </div>
        ) : (
          <button type="button" style={{ ...btn(true), marginTop: 6 }} onClick={() => { setErro(''); setForm(vazio); }}>
            <FiPlus size={14} /> Incluir contato
          </button>
        )}
      </div>
    </div>
  );
}

function Contatos() {
  const [dados, setDados] = useState({ clientes: [], cienciasHoje: [] });
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [soSem, setSoSem] = useState(false);
  const [aberto, setAberto] = useState(null);

  const carregar = useCallback(() => listarContatos().then(setDados).catch(e => setErro(e.message)).finally(() => setCarregando(false)), []);
  useEffect(() => { carregar(); }, [carregar]);

  const q = busca.trim().toLowerCase();
  const digitos = busca.replace(/\D/g, '');
  const semContato = dados.clientes.filter(c => !c.contatos.length).length;
  const lista = dados.clientes.filter(c => (!soSem || !c.contatos.length)
    && (!q || `${c.codigo} ${c.nome}`.toLowerCase().includes(q) || c.contatos.some(k => k.nome.toLowerCase().includes(q))
      || (digitos && String(c.cnpj || c.cpf || '').replace(/\D/g, '').includes(digitos))));
  const clienteAberto = dados.clientes.find(c => c.id === aberto);

  return (
    <div style={{ padding: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
        <span style={{ width: 40, height: 40, borderRadius: 10, background: '#e8f0fa', color: '#2f6db5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiUsers size={20} /></span>
        <h1 style={{ margin: 0, fontSize: 20, color: '#15365c', flex: 1 }}>Contatos</h1>
        <div style={{ position: 'relative', width: 320 }}>
          <FiSearch size={13} style={{ position: 'absolute', left: 10, top: 11, color: '#9ab0c4' }} />
          <input style={{ ...entrada, paddingLeft: 30 }} placeholder="Cliente, contato ou CNPJ..." value={busca} onChange={e => setBusca(e.target.value)} />
        </div>
        <button type="button" onClick={() => setSoSem(v => !v)}
          style={{ ...btn(false), borderColor: '#dc2626', background: soSem ? '#dc2626' : '#fef2f2', color: soSem ? '#fff' : '#b91c1c' }}>
          Sem contato · {semContato}
        </button>
      </div>

      {dados.cienciasHoje.length > 0 && (
        <p style={{ fontSize: 12, color: '#4A6B8A', margin: '0 0 10px' }}>
          Ciência de hoje do aviso: <strong>{dados.cienciasHoje[0].usuario_email}</strong> foi o primeiro, às {dados.cienciasHoje[0].hora}
          {dados.cienciasHoje.length > 1 && ` · depois: ${dados.cienciasHoje.slice(1).map(c => `${c.usuario_email} (${c.hora})`).join(', ')}`}
        </p>
      )}
      {erro && <p style={{ color: '#b91c1c', fontSize: 13 }}>{erro}</p>}

      {carregando ? <p style={{ fontSize: 13, color: '#6B8CAE' }}>Carregando...</p> : (
        <div style={{ display: 'grid', gap: 6 }}>
          {lista.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '9px 14px', border: `1px solid ${c.contatos.length ? '#e4edf5' : '#fecaca'}`, borderRadius: 10, background: c.contatos.length ? '#fff' : '#fff7f7' }}>
              <button type="button" onClick={() => setAberto(c.id)} title="Contatos deste cliente"
                style={{ ...btn(!c.contatos.length), padding: '7px 10px' }}><FiUserPlus size={15} /></button>
              <strong style={{ color: '#6B8CAE', minWidth: 44 }}>{c.codigo}</strong>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontWeight: 700, fontSize: 13, color: '#15365c' }}>{c.nome}</span>
                <span style={{ fontSize: 12, color: c.contatos.length ? '#6B8CAE' : '#b91c1c' }}>
                  {c.contatos.length ? c.contatos.map((k, i) => (
                    <React.Fragment key={k.id}>
                      {i > 0 && ' · '}{k.nome} ({TIPOS_CONTATO[k.tipo]}){k.possui_grupo && <EtiquetaGrupo />}
                    </React.Fragment>
                  )) : 'Sem contato vinculado'}
                </span>
              </span>
            </div>
          ))}
        </div>
      )}
      {clienteAberto && <ModalContatos cliente={clienteAberto} onFechar={() => setAberto(null)} onMudou={carregar} />}
    </div>
  );
}

export default Contatos;
